import React from 'react';
import '../styles/ServiceSection-css/ExploreServices.css';
import {
  FaBroom,
  FaTools,
  FaBug,
  FaSnowflake,
  FaBath,
  FaUtensils,
  FaHome,
  FaCouch,
  FaPlug,
  FaFaucet,
  FaRobot,
  FaMicrochip,
  FaHeadset,
  FaComments
} from 'react-icons/fa';

const categories = [
  { name: 'Home Cleaning', image: '/images/home.gif', icon: <FaBroom /> },
  { name: 'Repair Services', image: '/images/electrician.gif', icon: <FaTools /> },
  { name: 'Pest Control', image: '/images/pest.gif', icon: <FaBug /> },
  { name: 'AC & Appliances', image: '/images/ac.gif', icon: <FaSnowflake /> },
  { name: 'AI Services', image: '/images/ai.gif', icon: <FaRobot /> }
];

const subcategories = {
  'Home Cleaning': [
    { name: 'Bathroom Cleaning', image: '/images/bathroom.gif', icon: <FaBath /> },
    { name: 'Kitchen Cleaning', image: '/images/kitchen.gif', icon: <FaUtensils /> },
    { name: 'Full Home Cleaning', image: '/images/home.gif', icon: <FaHome /> },
    { name: 'Sofa & Carpet Cleaning', image: '/images/sofa.gif', icon: <FaCouch /> }
  ],
  'Repair Services': [
    { name: 'Electrician', image: '/images/electrician.gif', icon: <FaPlug /> },
    { name: 'Plumber', image: '/images/plumber.gif', icon: <FaFaucet /> }
  ],
  'Pest Control': [
    { name: 'Pest Control', image: '/images/pest.gif', icon: <FaBug /> }
  ],
  'AC & Appliances': [
    { name: 'AC Services', image: '/images/ac.gif', icon: <FaSnowflake /> }
  ],
  'AI Services': [
    { name: 'AI Chatbot Support', image: '/images/chatbot.gif', icon: <FaComments /> },
    { name: 'Voice Assistant Setup', image: '/images/voice.gif', icon: <FaHeadset /> },
    { name: 'Smart Home Integration', image: '/images/smarthome.gif', icon: <FaMicrochip /> },
    { name: 'Custom AI Solutions', image: '/images/ai_custom.gif', icon: <FaRobot /> }
  ]
};

const ExploreServices = () => {
  const [activeCategory, setActiveCategory] = React.useState('Home Cleaning');

  return (
    <>
      <div className="explore-container">
        <div className="explore-sidebar">
          <h2 className="sidebar-title">Categories</h2>
          {categories.map((cat, index) => (
            <div
              className={`category-item ${activeCategory === cat.name ? 'active' : ''}`}
              key={index}
              onClick={() => setActiveCategory(cat.name)}
            >
              <div className="icon">{cat.icon}</div>
              <span>{cat.name}</span>
            </div>
          ))}
        </div>

        <div className="explore-content">
          <h2 className="content-title">{activeCategory}</h2>
          <div className="subcategory-grid">
            {subcategories[activeCategory]?.map((item, index) => (
              <div className="subcategory-card" key={index}>
                <img src={item.image} alt={item.name} />
                <div className="subcategory-info">
                  <div className="sub-icon">{item.icon}</div>
                  <p>{item.name}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ExploreServices;
